var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.92V17.456C18.5001 17.7092 18.4042 17.953 18.2316 18.1382C18.059 18.3234 17.8226 18.4363 17.57 18.454C17.133 18.484 16.776 18.5 16.5 18.5C7.663 18.5 0.5 11.337 0.5 2.5C0.5 2.224 0.515 1.867 0.546 1.43C0.563722 1.17744 0.676581 0.941011 0.861804 0.768409C1.04703 0.595807 1.29082 0.499886 1.544 0.5H5.08C5.20404 0.499875 5.3237 0.545859 5.41573 0.62902C5.50776 0.712182 5.5656 0.826583 5.578 0.95C5.601 1.18 5.622 1.363 5.642 1.502C5.84073 2.88892 6.248 4.23783 6.85 5.503C6.945 5.703 6.883 5.942 6.703 6.07L4.545 7.612C5.86445 10.6865 8.31455 13.1365 11.389 14.456L12.929 12.302C12.9919 12.214 13.0838 12.1509 13.1885 12.1237C13.2932 12.0964 13.4042 12.1068 13.502 12.153C14.767 12.7539 16.1156 13.1601 17.502 13.358C17.641 13.378 17.824 13.4 18.052 13.422C18.1752 13.4346 18.2894 13.4926 18.3724 13.5846C18.4553 13.6766 18.5012 13.7961 18.501 13.92H18.5Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBar);
export default __webpack_public_path__ + "static/media/PhoneBar.4134a127ef623d26b146d819c0017f02.svg";
export { ForwardRef as ReactComponent };